// src/pages/Contact.jsx
import React, { useState, useEffect, useRef } from "react";
import "./../styles/styles.css"; 
import logo from "../assets/logo-titre.png";
import { useAuth } from "../context/AuthContext";
import RecaptchaV2 from "../components/RecaptchaV2";

export default function Contact() {
  const { user, isAuthenticated } = useAuth();

  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    sujet: "",
    message: "",
    cgu: false,
  });
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  // Ref pour réinitialiser le captcha après envoi
  const recaptchaRef = useRef(null);

  // Préremplir l'email si l'utilisateur est connecté
  useEffect(() => {
    if (isAuthenticated && user?.email) {
      setFormData((prev) => ({
        ...prev,
        email: user.email,
      }));
    }
  }, [isAuthenticated, user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleRecaptchaChange = (token) => {
    console.log("Token reCAPTCHA :", token); // debug
    setRecaptchaToken(token);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!recaptchaToken) {
      setError("❌ Veuillez valider le reCAPTCHA.");
      return;
    }

    setLoading(true);

    const API_URL = process.env.REACT_APP_API_URL;

    fetch(`${API_URL}/contact/contact.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData, recaptchaToken }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSuccess("✅ Votre demande a bien été envoyée !");
          setFormData({ nom: "", email: user?.email || "", sujet: "", message: "", cgu: false });
          setRecaptchaToken("");
          if (recaptchaRef.current) recaptchaRef.current.reset(); // réinitialiser visuellement le captcha
        } else {
          setError(data.message || "❌ Une erreur est survenue.");
        }
      })
      .catch((err) => {
        console.error(err);
        setError("❌ Impossible de contacter le serveur.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img
          src={logo}
          alt="Contact Immo Sans Agence"
          className="contact-banner"
          style={{ maxWidth: "60%", borderRadius: "8px", marginBottom: "1rem" }}
        />

        <h2>Contactez-nous</h2>
        <p className="login-subtitle">
          Une question, une suggestion ou un retour ? Remplissez le formulaire ci-dessous.
        </p>

        <form onSubmit={handleSubmit}>

          <div className="input-group">
            <label htmlFor="email">E-mail :</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="login-input"
              placeholder="Votre adresse email"
              required
              readOnly={isAuthenticated}
              style={isAuthenticated ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
            />
          </div>

          <div className="input-group">
            <label htmlFor="sujet">Sujet :</label>
            <input
              type="text"
              id="sujet"
              name="sujet"
              value={formData.sujet}
              onChange={handleChange}
              className="login-input"
              placeholder="Sujet de votre demande"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="message">Message :</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="login-input"
              placeholder="Votre message"
              rows="5"
              required
            />
          </div>

          <div className="recaptcha-wrapper">
            <RecaptchaV2 ref={recaptchaRef} onChange={handleRecaptchaChange} />
          </div>

          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Envoi en cours..." : "Envoyer"}
          </button>
        </form>
      </div>
    </div>
  );
}
